/**
 * Query keys for the account pages' data: the user detail fetch shared by the staff and
 * customer pages, plus the per-tab lists (credits, anytime tickets, invoices) and the global
 * pricing metadata the Pricing tab needs.
 */
export const userAccountKeys = {
	all: ['userAccount'] as const,
	details: () => [...userAccountKeys.all, 'detail'] as const,
	detail: (id?: string) => [...userAccountKeys.details(), id] as const,
	giftVouchers: (userId?: string) => [...userAccountKeys.all, 'giftVouchers', userId] as const,
	giftVoucherPage: (userId: string | undefined, filters: Record<string, unknown>) =>
		[...userAccountKeys.giftVouchers(userId), filters] as const,
	entitlements: (userId?: string) => [...userAccountKeys.all, 'entitlements', userId] as const,
	entitlementPage: (userId: string | undefined, filters: Record<string, unknown>) =>
		[...userAccountKeys.entitlements(userId), filters] as const,
	invoices: (userId?: string) => [...userAccountKeys.all, 'invoices', userId] as const,
	invoicePage: (userId: string | undefined, filters: Record<string, unknown>) =>
		[...userAccountKeys.invoices(userId), filters] as const,
	// Global (not user-specific) metadata for the Pricing tab.
	pricingFormData: () => ['userPricingFormData'] as const,
	pricingStrategyProfile: () => ['pricingStrategyProfile', 'default'] as const,
};
